import * as React from "react";
import { ThreadListWrapper, ThreadListHeader } from "./styledComponents";

interface IProps {
  header?: React.ReactNode | null;
  body?: React.ReactNode | null;
  top?: React.ReactNode | null;
  bottom?: React.ReactNode | null;
}

class ThreadList extends React.PureComponent<IProps> {
  public render() {
    return (
      <ThreadListWrapper>
        {this.props.header ? (
          <ThreadListHeader>{this.props.header}</ThreadListHeader>
        ) : null}
        {this.props.top ? <div>{this.props.top}</div> : null}
        {this.props.body ? <div>{this.props.body}</div> : null}
        {this.props.bottom ? <div>{this.props.bottom}</div> : null}
      </ThreadListWrapper>
    );
  }
}

export default ThreadList;
